import { addHours, isSameDay, isSunday, startOfDay } from 'date-fns';

export const needsExtraHour = (day: Date): boolean => {
  return isSunday(day) || [
    new Date(2026, 10, 11),
    new Date(2027, 0, 6),
    new Date(2027, 2, 29),
    new Date(2027, 4, 3),
    new Date(2027, 10, 1),
  ].some(d => isSameDay(d, day));
};

export const isDisabled = (day: Date, timeToOrder: number): boolean => {
  const adjustedTime = needsExtraHour(new Date()) ? timeToOrder + 1 : timeToOrder;
  return addHours(startOfDay(day), -adjustedTime).getTime() < Date.now();
};
